// src/hooks/useRecaptcha.js
import { useEffect } from "react";

export const useRecaptcha = (siteKey, visiblePages = []) => {
  useEffect(() => {
    // Prevent loading script multiple times
    if (!window.grecaptchaScriptLoaded) {
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
      window.grecaptchaScriptLoaded = true;
    }

    // Show or hide the badge depending on the current page
    const badge = document.querySelector(".grecaptcha-badge");
    if (badge) {
      badge.style.display = visiblePages.includes(window.location.pathname)
        ? "block"
        : "none";
    }

    // Cleanup: optional, don’t remove script so other pages can reuse it
    return () => {
      const badge = document.querySelector(".grecaptcha-badge");
      if (badge) badge.style.display = "none";
    };
  }, [siteKey, visiblePages]);
};

// Helper to execute reCAPTCHA action and get token
export const executeRecaptcha = async (siteKey, action = "default") => {
  if (!window.grecaptcha) return null;

  return await window.grecaptcha.execute(siteKey, { action });
};
